import classNames from 'classnames'
import React, { useEffect, useState } from 'react'
import {
    ButtonType,
    Columns,
    CustomButton,
    FormSavePrompt,
    InputWrapper,
    OverlaySpinner,
    TextInput
} from '../../components'
import { WemoloToggle } from '../../components/Wemolo'
import { useFormSaveStore } from '../../utils'
import styles from './AutoWhiteList.module.css'

type AutoWhiteListProps = {
    loading: boolean
    config: {
        autowhitelist?: {
            enable?: boolean
            duration_days?: number | null
        }
    } | null
    standalone?: boolean
    saveAutoWhitelistConfig: (enable: boolean, days: number | null) => void
    storeAutoWhiteListEnabled?: (enabled: boolean) => void
    storeAutoWhiteListDuration?: (duration: number | null) => void
}

export const AutoWhiteList = ({
    loading,
    config,
    saveAutoWhitelistConfig,
    standalone = false,
    storeAutoWhiteListEnabled,
    storeAutoWhiteListDuration
}: AutoWhiteListProps) => {
    const [autoWhitelistEnabled, setAutoWhitelistEnabled] = useState(false)
    const [enableInfiniteAutoWhitelist, setEnableInfiniteAutoWhitelist] = useState(false)
    const [numberOfDays, setNumberOfDays] = useState<null | number>(2)
    const disabled = !autoWhitelistEnabled
    const setFormChanges = useFormSaveStore((state) => state.setFormChanges)

    useEffect(() => {
        if (!loading && config !== null && config !== undefined) {
            // console.log('configdasa', config)
            setAutoWhitelistEnabled(config?.autowhitelist?.enable ?? false)
            storeAutoWhiteListEnabled?.(config?.autowhitelist?.enable ?? false)
            const isDurationUndefinedOrNull =
                config?.autowhitelist?.duration_days === null || config?.autowhitelist?.duration_days === undefined
            setEnableInfiniteAutoWhitelist(isDurationUndefinedOrNull)
            setNumberOfDays(isDurationUndefinedOrNull ? null : (config?.autowhitelist?.duration_days ?? 2))
            storeAutoWhiteListDuration?.(isDurationUndefinedOrNull ? null : (config?.autowhitelist?.duration_days ?? 2))
        }
        //eslint-disable-next-line
        return () => {
            setNumberOfDays(2)
            setEnableInfiniteAutoWhitelist(false)
            setAutoWhitelistEnabled(false)
        }
        //eslint-disable-next-line
    }, [loading, config])
    return (
        <OverlaySpinner loading={loading}>
            <div className={styles.root}>
                <FormSavePrompt />

                <div className={styles.column}>
                    <InputWrapper label="Enable Auto Whitelisting">
                        <WemoloToggle
                            size="small"
                            checked={autoWhitelistEnabled}
                            onChange={(e) => {
                                const value = e.target.checked
                                setFormChanges(true)
                                setAutoWhitelistEnabled(value)
                                storeAutoWhiteListEnabled?.(value)
                            }}
                        />
                    </InputWrapper>

                    <div
                        className={classNames(styles.toggleRow, {
                            [styles.toggleRowDisabled]: disabled
                        })}
                    >
                        <div className={styles.infiniteToggle}>
                            <InputWrapper label="Enable Infinite Whitelisting">
                                <WemoloToggle
                                    size="small"
                                    checked={enableInfiniteAutoWhitelist}
                                    onChange={(e) => {
                                        const value = e.target.checked
                                        setFormChanges(true)
                                        setEnableInfiniteAutoWhitelist(value)
                                        if (value) {
                                            storeAutoWhiteListDuration?.(null)
                                            setNumberOfDays(null)
                                        } else {
                                            if (
                                                numberOfDays === null ||
                                                config?.autowhitelist?.duration_days === null ||
                                                config?.autowhitelist?.duration_days === undefined ||
                                                numberOfDays === undefined
                                            ) {
                                                storeAutoWhiteListDuration?.(2)
                                                setNumberOfDays(2)
                                            }
                                        }
                                    }}
                                />
                            </InputWrapper>
                        </div>
                        <div> OR </div>
                        <div className={styles.daysInput}>
                            <InputWrapper label="Whitelist for x Number of days">
                                <TextInput
                                    onChange={(ev) => {
                                        setFormChanges(true)
                                        storeAutoWhiteListDuration?.(Number(ev.target.value))
                                        setNumberOfDays(Number(ev.target.value))
                                    }}
                                    disabled={enableInfiniteAutoWhitelist}
                                    value={numberOfDays !== null ? numberOfDays : ''}
                                    type="number"
                                    size="compact"
                                />
                            </InputWrapper>
                        </div>
                    </div>
                </div>

                {!standalone && (
                    <Columns
                        extraStyles={{
                            justifyContent: 'flex-end',
                            alignItems: 'flex-end',
                            flex: '40%'
                        }}
                    >
                        <CustomButton
                            onClick={() => {
                                setFormChanges(false)
                                saveAutoWhitelistConfig(autoWhitelistEnabled, numberOfDays)
                            }}
                            type={ButtonType.SAVE}
                            extraProps={{ minWidth: '270px !important;', marginTop: '15px' }}
                        >
                            Save Auto WL Config
                        </CustomButton>
                    </Columns>
                )}
                <div />
            </div>
        </OverlaySpinner>
    )
}
